export const masks = {
	'@type': 'Type',
	'@context': 'Context',
	sameAs: 'Social Media Accounts',
	url: 'Live Production URL',
};

export const orders = {
	schema: [
		'@type',
		'@context',
		'name',
		'description',
		'dateCreated',
		'releasedEvent',
		'image',
		'sameAs',
		'url',
		'director',
		'actor',
		'releasedEvent',
		'trailer',
	],
	releasedEvent: [
		'@type',
		'startDate',
		'location',
	],
	trailer: [
		'@type',
		'description',
		'name',
		'uploadDate',
		'url',
		'thumbnailUrl',
	],
	default: [
		'@type',
		'name',
	]
};

export const textAreas = [
	'description',
];

export const dates = [
	'dateCreated',
	'startDate',
	'uploadDate',
];

export function getName(string) {
	let name = '';
	if (string in masks) {
		name = masks[string];
	} else {
		name = camelCaseToTitleCase(string);
	}
	return name;
}

// use this method when pasting json in, to make it work with jsonPointer
// converts arrays to numbered objects
export function convertArraysToObjects(obj) {
	Object.keys(obj).forEach(key => {
		if (Array.isArray(obj[key])) {
			const newObj = {};
			obj[key].forEach((item, index) => {
				newObj[index] = item;
			});
			obj[key] = newObj;
		} else if (typeof obj[key] === 'object' && obj[key] !== null) {
			obj[key] = convertArraysToObjects(obj[key]);
		}
	});
	return obj;
}

// use this method when publishing site, to convert the numbered objects back to arrays
export function convertNumberedObjectsToArrays(obj) {
	Object.keys(obj).forEach(key => {
		if (typeof obj[key] === 'object' && obj[key] !== null) {
			const allKeysAreNumbers = Object.keys(obj[key]).every(k => !isNaN(k));
			if (allKeysAreNumbers) {
				const newArr = [];
				Object.keys(obj[key]).forEach(k => {
					newArr[Number(k)] = obj[key][k];
				});
				obj[key] = newArr;
			} else {
				obj[key] = convertNumberedObjectsToArrays(obj[key]);
			}
		}
	});
	return obj;
}

export function camelCaseToTitleCase(str) {
	const result = str.replace(/([A-Z])/g, ' $1');
	return result.charAt(0).toUpperCase() + result.slice(1);
}

export function titleCaseToCamelCase(str) {
	const result = str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
		index === 0 ? word.toLowerCase() : word.toUpperCase()
	).replace(/\s+/g, '');
	return result;
}